<form
  class="cart-lesson-form"
  (ngSubmit)="onSubmit()"
  novalidate
  [formGroup]="lessonForm"
  fxLayout="column"
  fxLayoutAlign="center center"
  fxLayoutGap="20px"
  >
  <section
    class="cart-lesson-body"
    fxLayout="row"
    fxLayout.lt-lg="column"
    fxLayoutAlign="space-between center"
    fxLayoutAlign.lt-lg="center none"
    fxLayoutGap="20px"
    >
    <lesson-form-fields
      [parent]="lessonForm"
      [programs]="[selectedEdition]"
      [lessonUnits]="lessonUnits"
      [lessonLevels]="lessonLevels"
      [levelLabel]="levelLabel"
      [selectedAssets]="selectedAssets"
      [subjectId]="subjectId"
      [editionId]="editionId"
      (languageChange)="onLanguageChange($event)"
      (getFormData)="getFormData()"
      >
    </lesson-form-fields>
  </section>

  <section class="cart-lesson-footer" fxFlex>
    @if (exists && assetInUse) {
      <mat-error class="cart-warning-message">
        <mat-icon class="warning-icon">warning</mat-icon>
        Warning: This Bundle has outstanding assignments.
      </mat-error>
    }
  </section>
</form>
